import api from "./apiClient.js";

const endpoint = "pin";

export const getAllPins = () => {
	return api.get(endpoint);
};

export const getPinById = (id) => {
	return api.get(endpoint + "/" + id);
};

export const createPin = (pin) => {
	return api.post(endpoint, pin);
};

export const updatePin = (pin) => {
	return api.put(endpoint + "/" + pin.id, pin);
};

export const deletePin = (id) => {
	return api.delete(endpoint + "/" + id);
};
